module.exports = __webpack_public_path__ + "media/images/lb/452-b97dd340cc711333ff71a80517d1090b.svg";